import { normalizeLocale, type SupportedLocale } from './config';
export type ChannelDriveCopy = {
  channelLabel: string;
  channelAudienceManaged: string;
};
const COPY: Record<SupportedLocale, ChannelDriveCopy> = {
  en: {
    channelLabel: 'Channel',
    channelAudienceManaged:
      'Access follows this channel’s current members and permissions. Manage membership in the channel.',
  },
  'pt-BR': {
    channelLabel: 'Canal',
    channelAudienceManaged:
      'O acesso segue os membros e as permissões atuais deste canal. Gerencie os membros no canal.',
  },
  ar: {
    channelLabel: 'القناة',
    channelAudienceManaged:
      'يتبع الوصول أعضاء هذه القناة وأذوناتهم الحالية. يمكنك إدارة العضوية من القناة.',
  },
  de: {
    channelLabel: 'Kanal',
    channelAudienceManaged:
      'Der Zugriff richtet sich nach den aktuellen Mitgliedern und Berechtigungen dieses Kanals. Verwalte die Mitgliedschaft im Kanal.',
  },
  es: {
    channelLabel: 'Canal',
    channelAudienceManaged:
      'El acceso depende de los miembros y permisos actuales de este canal. Gestiona los miembros en el canal.',
  },
  fr: {
    channelLabel: 'Canal',
    channelAudienceManaged:
      'L’accès suit les membres et les autorisations actuels de ce canal. Gérez les membres dans le canal.',
  },
  it: {
    channelLabel: 'Canale',
    channelAudienceManaged:
      'L’accesso segue i membri e le autorizzazioni attuali di questo canale. Gestisci i membri nel canale.',
  },
  ko: {
    channelLabel: '채널',
    channelAudienceManaged:
      '접근 권한은 이 채널의 현재 멤버와 권한을 따릅니다. 채널에서 멤버를 관리하세요.',
  },
  ja: {
    channelLabel: 'チャンネル',
    channelAudienceManaged:
      'アクセスは、このチャンネルの現在のメンバーと権限に従います。メンバーはチャンネルで管理してください。',
  },
  hi: {
    channelLabel: 'चैनल',
    channelAudienceManaged:
      'पहुँच इस चैनल के मौजूदा सदस्यों और अनुमतियों के अनुसार तय होती है। सदस्यता चैनल में प्रबंधित करें।',
  },
  ru: {
    channelLabel: 'Канал',
    channelAudienceManaged:
      'Доступ определяется текущими участниками и разрешениями этого канала. Управляйте участниками в канале.',
  },
  zh: {
    channelLabel: '频道',
    channelAudienceManaged:
      '访问权限遵循此频道的当前成员和权限设置。请在频道中管理成员。',
  },
  'zh-TW': {
    channelLabel: '頻道',
    channelAudienceManaged:
      '存取權限依據此頻道的目前成員和權限設定。請在頻道中管理成員。',
  },
  vi: {
    channelLabel: 'Kênh',
    channelAudienceManaged:
      'Quyền truy cập tuân theo thành viên và quyền hiện tại của kênh này. Quản lý thành viên trong kênh.',
  },
  id: {
    channelLabel: 'Saluran',
    channelAudienceManaged:
      'Akses mengikuti anggota dan izin saat ini di saluran ini. Kelola keanggotaan di saluran.',
  },
};
export function getChannelDriveCopy(locale: string): ChannelDriveCopy {
  return COPY[normalizeLocale(locale)];
}
